import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import { Button, P, Wrapper } from '@farewill/ui'
import { GTR } from '@farewill/ui/tokens'
import { hideModal } from 'state/actions'

const StyledWrapper = styled(Wrapper)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: ${GTR.S};
`

const StyledCancelButton = styled(Button.Danger)`
  flex: 1;
`

const StyledExitButton = styled(Button.BorderedDark)`
  flex: 1;
`

type ModalProps = {
  config: {
    handleCancelPlan: () => Promise<void>
  }
}

const CancelPlanModal = ({ config }: ModalProps) => {
  const dispatch = useDispatch()

  const handleContinue = async () => {
    await config.handleCancelPlan()
    dispatch(hideModal())
  }

  return (
    <Wrapper>
      <P>
        This cannot be undone. If the customer changes their mind, you will need
        to sell them a new plan.
      </P>
      <StyledWrapper>
        <StyledCancelButton type="button" onClick={handleContinue}>
          Cancel the plan
        </StyledCancelButton>
        <StyledExitButton type="button" onClick={() => dispatch(hideModal())}>
          Go back
        </StyledExitButton>
      </StyledWrapper>
    </Wrapper>
  )
}

export default CancelPlanModal
